"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slice = exports.order = exports.filter = void 0;
var serializeValue = function (value) {
    if (value === null)
        return 'null';
    if (typeof value === 'string')
        return "'".concat(value, "'");
    if (Array.isArray(value))
        return JSON.stringify(value);
    return value;
};
/**
 * A function that builds a filter query.
 * @param field - The field to apply the filter on.
 * @param operator - The filter operator.
 * @param value - The filter value.
 * @returns A filter query.
 * @example
 * const filterQuery = filter('name', 'match', 'John')
 */
var filter = function (field, operator, value) { return ({
    type: 'filter',
    field: field,
    operator: operator,
    value: serializeValue(value),
}); };
exports.filter = filter;
/**
 * A function that builds an order query.
 * @param field - The field to apply the sorting on.
 * @param direction - The sort direction.
 * @returns An order query.
 * @example
 * const orderQuery = order('age', 'asc')
 */
var order = function (field, direction) { return ({
    type: 'order',
    field: field,
    direction: direction,
}); };
exports.order = order;
/**
 * A function that builds a slice query.
 * @param startIndex - The index to begin slicing the documents from.
 * @param endIndex - The amount of documents to return.
 * @param inclusive - Whether to include the document at the endIndex or not.
 * @returns A slice query.
 * @example
 * const sliceQuery = slice(0, 10, true)
 */
var slice = function (startIndex, endIndex, inclusive) { return ({
    type: 'slice',
    startIndex: startIndex,
    endIndex: endIndex,
    inclusive: inclusive,
}); };
exports.slice = slice;
//# sourceMappingURL=query-constraint.js.map